import React from 'react';
import _ from 'lodash';
import Moment from 'moment';

import { DropdownServiceLogo } from './DropdownServiceLogo';
import { ToggleConference } from './ToggleConference';
import { AccountMenu } from './AccountMenu';
import { GlobalHeaderFieldSelect } from './GlobalHeaderFieldSelect';
import { GlobalHeaderDateSelector } from './GlobalHeaderDateSelector';
import urlParamManager from '../utilities/urlParamManager';
import { NotificationService } from '../services/Notification';
import LocalStorageService from '../services/utilities/LocalStorageService';
import NotificationUtility from '../utilities/notificationUtility';
import HeaderNotification from './HeaderNotifications';
import { Modal } from '../components/Modal';
import { NotificationDetail } from './modals/NotificationDetail';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { NotificationConstants } from '../utilities/notificationConstants';
import EventMg, { EventType } from '../utilities/EventManager';
import masterSlideLoader from '../utilities/masterSlideLoader';
import {
  NOTIFICATIONS_FILTER_TYPE,
  DATE_TIME_FORMAT,
  NOTIFICATION_LOAD_DURATION,
} from '../utilities/constants';
import { isNullOrUndefinedOrEmptyStr } from '../utilities/stringUtil';
import { HelpMenu } from './HelpMenu';
import { isTrackerPath } from '../utilities/trackerUtil';

Moment.locale('ja');
/**
 * ヘッダー
 *
 * @export
 * @class GlobalHeader
 * @extends {React.Component}
 */
export class GlobalHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalState: false,
      conference: false,
      split: [],
      notificationList: [], // 「あなたへの重要なお知らせがn件あります」の表示
      unreadCount: 0,
      vw: 1,
      limit: 30,
    };
    this.unreadCount = 0;
    this.strongNotificationsCount = 0;
    this.noticesListLoadedFlag = false;
    this.userId = LocalStorageService.getUserId(); // ユーザーID

    this.noticeRef = React.createRef();
    this.calledGetUnreadFlag = false;
  }

  componentDidMount() {
    if (isTrackerPath()) {
      return;
    }

    urlParamManager.setDelegate(split => {
      this.setState({ split });
    });

    urlParamManager.pageWillLoad(split => {
      this.setState({ split });
    });
  }

  shouldComponentUpdate() {
    const token = SessionStorageService.getToken();
    const isLogout = LocalStorageService.getItem('is_logout');
    // ログアウト後に呼ばれるの防止する
    if (!_.isEmpty(token) && isLogout !== '1') {
      // 最初の１回のみapi呼び出す
      if (this.calledGetUnreadFlag === false) {
        this.calledGetUnreadFlag = true;
        // ログインユーザーの通知一覧API呼び出し
        this.getUnreadCount();
      }
    }

    return true;
  }

  isExpiredUsage = data => {
    const { field_usage_end_date } = data;

    if (!field_usage_end_date) {
      return false;
    }

    const usageEndDate = Moment(
      field_usage_end_date,
      DATE_TIME_FORMAT.slashDateFormat
    );
    const today = Moment();
    return usageEndDate.isBefore(today.subtract(1, 'day'));
  };

  // 通知強リスト
  strongNotifications = () => {
    const notifications = _.filter(
      this.state.notificationList,
      notification => {
        return NotificationUtility.isStrongNotification(notification);
      }
    );

    const notexpirednotifications = _.filter(notifications, notification => {
      return !this.isExpiredUsage(notification);
    });

    const unreadnotifications = _.filter(
      notexpirednotifications,
      notification => {
        return notification.read_flag === false;
      }
    );
    // 作業実績未入力通知は何件あっても1カウント
    const worknotifications = _.find(unreadnotifications, notification => {
      return (
        notification.message_type_id ===
          NotificationConstants.conferenceWorkPlansNotEnteredNotification
            .messageTypeId ||
        notification.message_type_id ===
          NotificationConstants
            .conferenceWorkPlansNotEnteredAndNotCopyNotification.messageTypeId
      );
    });
    // 作業実績未入力通知以外の通知をカウント
    const notworknotifications = _.filter(unreadnotifications, notification => {
      return !(
        notification.message_type_id ===
          NotificationConstants.conferenceWorkPlansNotEnteredNotification
            .messageTypeId ||
        notification.message_type_id ===
          NotificationConstants
            .conferenceWorkPlansNotEnteredAndNotCopyNotification.messageTypeId
      );
    });
    if (!_.isUndefined(worknotifications)) {
      // 作業実績未入力通知あり
      this.strongNotificationsCount = notworknotifications.length + 1;
    } else {
      // 作業実績未入力通知なし
      this.strongNotificationsCount = unreadnotifications.length;
    }
    if (this.noticesListLoadedFlag) {
      SessionStorageService.setStrongtNotificationCount(
        this.strongNotificationsCount
      );
      this.noticesListLoadedFlag = false;
    }

    return unreadnotifications;
  };

  // 最新の通知強
  latestStrongNotification = () => {
    const notification = _.maxBy(this.strongNotifications(), notification => {
      return notification.id;
    });
    return notification;
  };

  // 指摘事項ダイアログの右の青ボタン押下時
  handleExecute = () => {
    const notification = this.latestStrongNotification();
    const { message_type_id, id } = notification;
    NotificationUtility.executeActionNotificationStrong(message_type_id, {
      id,
    });
  };

  // 通知強のモーダル
  renderModalDialog = () => {
    if (this.latestStrongNotification()) {
      return (
        <NotificationDetail
          dialogTitle={this.latestStrongNotification().title}
          dialogContent={this.latestStrongNotification().content}
          dialogBlueButtonTitle={NotificationUtility.hasBlueButtonTitle(
            this.latestStrongNotification()
          )}
          onClose={() => this.setState({ modalState: false })}
          onExecute={() => {
            this.handleExecute();
            this.setState({ modalState: false });
          }}
        />
      );
    }
  };

  // 会議ボタン表示設定
  conferenceMode(element) {
    //会議モードにしたいページのurl内のページ表記を配列に入れる
    const conferencePages = [
      'WorkSchedule',
      'WorkResult',
      'GatePassages',
      'CraneUses',
      'MachineryUses',
      'SafetyDiaries',
    ];

    let pages = _.filter(this.state.split, split => {
      const pageName = split.split(':')[0];
      if (
        [
          'WorkScheduleAll',
          'WorkScheduleBatchEdit',
          'WorkResultBatchEdit',
          'WorkScheduleMultipleEdit',
          'WorkResultMultipleEdit',
        ].includes(pageName)
      ) {
        // 正規表現でworkScheduleと同じ判定になるため分割
        return false;
      }
      const regexp = new RegExp(`^(${conferencePages.join('|')}).*`, 'g');
      return split.match(regexp);
    });
    return pages.length ? element : <div />;
  }

  /**
   * ログインユーザーの通知一覧
   *
   * @memberof GlobalHeader
   */
  getUnreadCount(notify) {
    const lastNotificationListLoaded = SessionStorageService.getLastNotificationLoaded();
    const today = Moment();

    if (isNullOrUndefinedOrEmptyStr(lastNotificationListLoaded)) {
      SessionStorageService.setLastNotificationLoaded(today);
    } else if (
      today.diff(Moment(lastNotificationListLoaded), 'minutes') <
      NOTIFICATION_LOAD_DURATION
    ) {
      this.calledGetUnreadFlag = false;
      return;
    }

    NotificationService.list({
      isQuiet: true,
      offset: notify ? _.size(this.state.notificationList) : 0,
      limit: this.state.limit,
      order: 'display_start_date_desc',
      field_id: SessionStorageService.getFieldId()
    })
      .then(response => {
        if (!response.result) {
          return;
        }
        this.noticesListLoadedFlag = true;
        SessionStorageService.setLastNotificationLoaded(today);
        // https://e-reverse.backlog.jp/view/BLDE_V2-15432 仕様変更
        // this.unreadCount = response.data.entities.unread_count;
        // // 未読の件数を取得して子コンポーネントに再描画させるため、親からステートを更新する
        // if (this.noticeRef.current !== null) {
        //   this.noticeRef.current.fireRender(this.unreadCount);
        // }
        this.setState(
          { notificationList: response.data.entities.notices },
          () => {
            EventMg.trigger(EventType.LAYOUT_UPDATE, {});
            // 通知強のオレンジバー表示時にコンポーネントの縦サイズ設定がおかしくなり
            // スクロールバーの描画位置がおかしくなり画面下にうまる不具合があり
            // その対応のためにState更新後に LAYOUT_UPDATE を実行する
          }
        );
      })
      .then(() => {
        this.calledGetUnreadFlag = false;
      });
  }

  /**
   * 「通知一覧」ページを開く
   * */
  openNotifications = () => {
    masterSlideLoader.show('Notices', {
      state: {},
    });
  };

  render() {
    const { modalState, unreadCount } = this.state;

    // ヘッダーの日付選択非表示
    const noShowDateFlag = sessionStorage.getItem('slideClosed') === '0';
    sessionStorage.removeItem('slideClosed');

    return (
      <div className='global-header global-header--rail'>
        <div className='global-header__bar'>
          <DropdownServiceLogo />
          <div className='global-header__item'>
            <GlobalHeaderFieldSelect />
          </div>
          <div
            style={{
              display: 'flex',
              order: 3,
              flex: '1 1 auto',
            }}
          >
            <GlobalHeaderDateSelector
              positionKey={'Global'}
              noShowDateFlag={noShowDateFlag}
            />
          </div>
          <div className='global-header__menu'>
            {this.conferenceMode(
              <ToggleConference
                handleToggleConference={this.props.handleToggleConference}
              />
            )}
            <HelpMenu />
            <HeaderNotification
              ref={this.noticeRef}
              unreadCount={unreadCount}
              vw={this.state.vw}
              callback={this.getUnreadCount.bind(this)}
            />
            <div className='global-header__account'>
              <AccountMenu />
            </div>
          </div>
        </div>
        {(this.strongNotifications().length > 0 ||
          SessionStorageService.getStrongtNotificationCount() > 0) && (
          <div className='global-header__message show'>
            <div className='message'>
              <a href='javascript:void(0)' tabIndex={-1} onClick={this.openNotifications}>
                あなたへの重要なお知らせが
                {SessionStorageService.getStrongtNotificationCount()}
                件あります
              </a>
            </div>
            {/* 通知強モーダル */}
            <Modal modalRoot={'root'} modalState={modalState === true}>
              {this.renderModalDialog()}
            </Modal>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GlobalHeader.jsx